import options from './empty-state.component';

export default {
    selector: 'dtEmptyState',
    options
};



// WEBPACK FOOTER //
// ./app/common/empty-state/index.js